import styles from "./NotFound.module.css";
import { Button } from "antd";
import Utils from "../../utils";

const NotFound = () => {
  return (
    <div className={styles.errorPage}>
      <section className={styles.error_container}>
        <span>4</span>
        <span>0</span>
        <span>4</span>
      </section>
      <p className={styles.zoom_area}>
        Oops! Could not find the requested resource.
      </p>
      <div className={styles.link_container}>
        <Button type="primary" onClick={() => Utils.redirectUrl(`/dashboard`)}>
          Return to Home Page
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
